import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`v1/api/perm/roles?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`v1/api/perm/roles/${id}`, { params });
}

export async function create(body) {
  return request(`v1/api/perm/roles`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`v1/api/perm/roles/${id}`, {
    method: 'POST',
    body,
  });
}
export async function deleteRecord(id) {
  return request(`v1/api/perm/roles/${id}`, {
    method: 'DELETE',
  });
}